module.exports = __webpack_public_path__ + "_/img/MapMarker3_Red.2ae4585d.svg";